module.exports = "<main>\n    Table with all bookings\n    <ul>\n        <li ng-repeat=\"reference in vm.bookings\">\n            <a href=\"\" ui-sref=\"bookings.booking.view({bookingReference: reference})\">{{reference}}</a>\n        </li>\n    </ul>\n</main>"


//////////////////
// WEBPACK FOOTER
// ./client/app/routes/bookings/bookings.html
// module id = 110
// module chunks = 0